module.exports = __webpack_public_path__ + "img/full0-min.2fdb6dc2.png";